import styled from "styled-components";
import * as UIConstants from "../../UIConstants";

export const HeaderView = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const FormContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: 10px;
  margin-top: 25px;
  form {
    width: 100%;
    box-sizing: border-box;
  }
  ${UIConstants.customView} {
    display: inline-block;
  }
`;

export const FormWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: #ffffff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
`;

export const SkeletonWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const SectionWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
`;

export const SectionTitle = styled.div`
  width: 100%;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.0024em;
  color: #200e32;
  padding: 30px 0 30px 24px;
  border-bottom: 1px solid #e9edf5;
`;
export const FormBody = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 30px 24px 30px 24px;
`;

export const ImageSection = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #ffffff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  margin-bottom: 24px;
  padding: 20px;
  gap: 30px;
`;
export const ActionBtn = styled.div`
  width: 100%;
  box-sizing: border-box;
  text-align: right;
  margin: 0 0 50px 0;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  column-gap: 15px;
  Button {
    border-radius: 8px;
    width: 150px;
  }
`;
